import React from 'react';

const StatsCardSkeleton: React.FC = () => {
  return (
    <div className="stat-card animate-pulse">
      <div className="flex items-start justify-between mb-4">
        {/* Ícone skeleton */}
        <div className="w-12 h-12 bg-neutral-200 rounded-xl"></div>
        
        {/* Indicador de mudança skeleton */}
        <div className="flex items-center space-x-1">
          <div className="w-8 h-3 bg-neutral-200 rounded"></div>
          <div className="w-3 h-3 bg-neutral-200 rounded"></div>
        </div>
      </div>
      
      <div className="space-y-2">
        {/* Label skeleton */}
        <div className="w-24 h-4 bg-neutral-200 rounded"></div>
        
        {/* Valor skeleton */}
        <div className="w-16 h-8 bg-neutral-200 rounded"></div>
        
        {/* Descrição skeleton */}
        <div className="w-32 h-3 bg-neutral-200 rounded"></div>
      </div>

      {/* Linha decorativa skeleton */}
      <div className="absolute bottom-0 left-0 right-0 h-1 bg-neutral-200 rounded-b-2xl"></div>
    </div>
  );
};

export default StatsCardSkeleton; 